/** Tracks one in-flight feature-matrix save so a later toggle is not discarded. */
export type FeatureSaveQueue = {
  /** Latest local edit. */
  gen: number;
  /** Edit generation currently being written, if a request is in flight. */
  inFlightGen: number | null;
};

export const initialFeatureSave = (): FeatureSaveQueue => ({ gen: 0, inFlightGen: null });

/** Record a local edit. Arm the debounce only when nothing is already being written. */
export function noteFeatureEdit(q: FeatureSaveQueue): { queue: FeatureSaveQueue; armTimer: boolean } {
  return {
    queue: { gen: q.gen + 1, inFlightGen: q.inFlightGen },
    armTimer: q.inFlightGen === null,
  };
}

export function noteFeatureSaveStart(q: FeatureSaveQueue): FeatureSaveQueue {
  return { gen: q.gen, inFlightGen: q.gen };
}

/**
 * A save of `savedGen` finished. Drop the draft only when no newer edit arrived.
 * Otherwise arm another save for the edits that landed mid-request.
 */
export function noteFeatureSaveFinish(
  q: FeatureSaveQueue,
  savedGen: number,
): { queue: FeatureSaveQueue; clearDraft: boolean; armTimer: boolean } {
  const newer = q.gen !== savedGen;
  return {
    queue: { gen: q.gen, inFlightGen: null },
    clearDraft: !newer,
    armTimer: newer,
  };
}
